export default __webpack_public_path__ + "static/img-ef-9-914bed006dc9c432c6298d31b13bd491.png";